/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homebadgeopensource3Inputs */



/**
* | output |
* | --- |
* | "Open source" |
*
* @param {Homebadgeopensource3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homebadgeopensource3 = /** @type {((inputs?: Homebadgeopensource3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homebadgeopensource3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Open source")
	return /** @type {LocalizedString} */ ("Open Source")
});
export { homebadgeopensource3 as "homeBadgeOpenSource" }